import { getUTCNow, toLocalMidnight } from '@app/utils/date.utils'
import { DateRange } from '../models/date-range.model'

export const defaultDateRange = {
    from: toLocalMidnight(getUTCNow(-30)),
    to: toLocalMidnight(getUTCNow())
} as DateRange
